import { FC } from "react";

import { LandingCompanyIdEnum, TLandingCompanyId } from "@ryde/utils-landings";

import { LandingStepsContainer } from "./landing-steps-container";
import { ClalLandingStepsContainer } from "./landing-steps-container.clal";
import { HerzliyaLandingStepsContainer } from "./landing-steps-container.herzliya";
import { NvidiaShuttleLandingStepsContainer } from "./landing-steps-container.nvidiashuttle";
import { TnufaLandingStepsContainer } from "./landing-steps-container.tnufa";
import { WestNegevLandingStepsContainer } from "./landing-steps-container.westnegev";
import { WixLandingStepsContainer } from "./landing-steps-container.wix";

export interface IStepsContainerType {
  containerId?: TLandingCompanyId;
}

export const RenderStepsContainerMap: FC<IStepsContainerType> = ({
  containerId,
}) => {
  switch (containerId) {
    case LandingCompanyIdEnum.Herzliya:
      return <HerzliyaLandingStepsContainer />;

    case LandingCompanyIdEnum.Clal:
      return <ClalLandingStepsContainer />;

    case LandingCompanyIdEnum.Tnufa:
      return <TnufaLandingStepsContainer />;

    case LandingCompanyIdEnum.WestNegev:
      return <WestNegevLandingStepsContainer />;

    case LandingCompanyIdEnum.NvidiaShuttle:
      return <NvidiaShuttleLandingStepsContainer />;

    case LandingCompanyIdEnum.Wix:
      return <WixLandingStepsContainer />;

    default:
      return <LandingStepsContainer />;
  }
};
